/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component() {
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">


  <div class="page-content" style="background: linear-gradient(180deg, #121212 0%, #000000 100%);">




    <div class="control-size">

      <div class="block" style="margin-bottom: 0px; margin-top: 0px;">
        <H1>Today</H1>
      </div>
      
      <div class="z-card" style="background-image: url(static/images/opt_1.jpg);">
        <span class="z-label">MFTS</span><br/>Untung Pantas
        <div class="z-card-footer">
          <div class="row" >
            <div class="col-70">
              <span class="z-label">MFTS</span><br/>
              Untung 100% sebulan<br/>
              <span class="z-label">Dagangan high risk</span><br/>
            </div>
            <div class="col-30">
              <a href="/account/" class="button button-fill button-round">JOIN</a>
            </div>
          </div>
          
        </div>
      </div>  

      <div class="z-card" style="background-image: url(static/images/opt_2.jpg);">
        <span class="z-label">MFTS</span><br/>Untung Perlahan
        <div class="z-card-footer">
          <div class="row" >
            <div class="col-70">
              <span class="z-label">MFTS</span><br/>
              Untung 100% setahun<br/>
              <span class="z-label">Dagangan low risk</span><br/>
            </div>
            <div class="col-30">
              <a href="/account/" class="button button-fill button-round">JOIN</a>
            </div>
          </div>
          
        </div>
      </div>  

 

    

    </div>
  </div>
</div>
`
    }
    ;
}

framework7Component.id = '50b6dc0382';
export default framework7Component;